import React, { createContext, useContext, useState, useMemo } from 'react';

interface WikiItemContextType {
  currentItemName: string | null;
  setCurrentItemName: (name: string | null) => void;
  isItemLoading: boolean;
  setIsItemLoading: (loading: boolean) => void;
}

const WikiItemContext = createContext<WikiItemContextType | undefined>(undefined);

export const WikiItemProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentItemName, setCurrentItemName] = useState<string | null>(null);
  const [isItemLoading, setIsItemLoading] = useState<boolean>(false);

  const value = useMemo<WikiItemContextType>(() => ({
    currentItemName,
    setCurrentItemName,
    isItemLoading,
    setIsItemLoading
  }), [currentItemName, isItemLoading]);

  return (
    <WikiItemContext.Provider value={value}>
      {children}
    </WikiItemContext.Provider>
  );
};

export const useWikiItem = (): WikiItemContextType => {
  const context = useContext(WikiItemContext);
  if (context === undefined) {
    throw new Error('useWikiItem must be used within a WikiItemProvider');
  }
  return context;
};